import React from "react";

export const HurricaneIcon = () => (
    <svg
        tabIndex={-1}
        focusable="false"
        className="svg-icon icon-weather"
        width="80px"
        height="80px"
        fill="none"
        viewBox="0 0 80 80"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g className="weather-fill" id="02" fillRule="nonzero" fill="#3F4447">
                <g transform="translate(13.000000, 13.000000)">
                    <path
                        d="M51.256 14.97c-7.603 0-14.59 3.661-18.948 9.718a2.075 2.075 0 01-2.984.406 14.923 14.923 0 01-5.593-11.66c0-.958.09-1.901.266-2.822a23.317 23.317 0 00-8.643 18.132c0 7.58 3.638 14.548 9.665 18.91a2.075 2.075 0 01.453 2.913 14.929 14.929 0 01-12.039 6.085c-.957 0-1.9-.09-2.82-.267a23.317 23.317 0 0018.131 8.644c7.603 0 14.59-3.66 18.948-9.717a2.075 2.075 0 012.984-.406 14.923 14.923 0 015.593 11.66c0 .958-.09 1.901-.266 2.822a23.317 23.317 0 008.644-18.132c0-7.58-3.639-14.548-9.666-18.91a2.075 2.075 0 01-.453-2.913 14.929 14.929 0 0112.039-6.085c.957 0 1.9.09 2.82.266a23.317 23.317 0 00-18.131-8.643zm0-4.149a27.48 27.48 0 0125.23 16.575c.857 1.983-1.508 3.793-3.198 2.448a10.744 10.744 0 00-6.721-2.346 10.767 10.767 0 00-7.362 2.897 27.423 27.423 0 019.591 20.86 27.48 27.48 0 01-16.575 25.23c-1.982.858-3.793-1.507-2.447-3.197a10.744 10.744 0 002.346-6.721c0-2.596-.92-5.038-2.536-6.955a27.423 27.423 0 01-20.84 9.567A27.48 27.48 0 013.515 52.603c-.857-1.982 1.507-3.792 3.197-2.447a10.744 10.744 0 006.721 2.346c2.787 0 5.395-1.061 7.363-2.897a27.422 27.422 0 01-9.592-20.86 27.48 27.48 0 0116.575-25.23c1.983-.858 3.793 1.507 2.448 3.197a10.744 10.744 0 00-2.346 6.721c0 2.596.92 5.038 2.536 6.955a27.423 27.423 0 0120.839-9.567zM40 48.362a8.362 8.362 0 110-16.724 8.362 8.362 0 010 16.724zm0-4.15a4.213 4.213 0 100-8.425 4.213 4.213 0 000 8.425z"
                        fill="#717277"
                    />
                </g>
            </g>
        </g>
    </svg>
);
